import { makeStyles } from '@material-ui/core/styles';

const styles = makeStyles(({ spacing, typography, palette, variables }) => ({
  infoBarHeader:{
    height:'65px'
  },
  segmentedControlContainer:{
    padding:variables?.spacingD,
    '&.fixed':{
      position:'fixed',
      backgroundColor:'#FCFCFC',
      width:'368px',
      zIndex:6,
    }
  },
  infoBar: {
    width: '375px',
    flexShrink: 0,
    position: 'relative',
    zIndex: 5,
    // boxShadow: '0px 2px 16px rgba(0, 0, 0, 0.2)',
    overflow: 'scroll',
    '&::-webkit-scrollbar': {
      '-webkit-appearance': 'none',
      'width': '7px'
  },
  '&::-webkit-scrollbar-thumb': {
      borderRadius: '4px',
      backgroundColor: 'rgba(0,0,0,.5)',
      boxShadow: '0 0 1px rgba(255,255,255,.5)'
  },
    '& ul': {
      //overflow: 'auto',
    },
    '&.mobile': {
      zIndex: 0,
      width: '100%',
      boxShadow: 'inherit',
      height: 'calc(100% - 72px)',
      overflow: 'auto',
    },
  },
  infoBarMapView: {
    width: '100%',
    position: 'absolute',
    bottom: '50px',
    backgroundColor: '#fff',
    zIndex: 2,
    maxHeight: '170px',
    minHeight: '100px',
  },
  header: {
    display: 'flex',
    flexShrink: 0,
    backgroundColor: palette.background.default,
    '& button': {
      backgroundColor: 'transparent',
      border: 'none',
      flex: 1,
      textAlign: 'center',
      padding:`${variables?.spacingC} ${variables?.spacingB}`,
      margin: 0,
      color: palette.tab?.main,
      font: `700 1rem/1.5 ${typography.fontFamily}`,
      cursor: 'pointer',
      borderBottom: `2px solid transparent`,
      '&.active': {
        color: palette.secondary.main,
        borderBottom: `2px solid ${palette.secondary.main}`,
      },
    },
  },
  inviteButton: {
    height: '56px',
    borderRadius: '2px',
  },
}));

export default styles;
